
import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { SelectableLab } from '../carrier/selectable-lab';
import { WorkFlowNGS } from '../masterdata/models/workFlow';
import * as cloneDeep from 'lodash/cloneDeep';
import * as omit from 'lodash/omit';
import { BBResponseContainer } from '../carrier/response-container';
import { SelectItem } from 'primeng/api/selectitem';
import { ProcessFlow } from '../masterdata/models/processFlow';

@Component({
  selector: 'app-app-workflow-ngs',
  templateUrl: './app-workflow-ngs.component.html',
  styleUrls: ['./app-workflow-ngs.component.css']
})
export class AppWorkflowNgsComponent implements OnInit {

  @Input() masterLists: Array<WorkFlowNGS>;
  _labOptions: Array<LabMDM>;
  @Input() workFlowHeaders: Array<any>;
  @Input() title: string;
  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }
  @Input() checkSelectedLab: SelectableLab;
  errorHandler: ErrorHandler = new ErrorHandler();
  workFlowGroupsOptions: Array<any>;
  processScaleOptions: Array<any>;
  mergeInStatusOptions :Array<any>;
  statusAfterMergeOptions: Array<any>;
  selectedWorkFlow: any;
  workFlow: WorkFlowNGS;
  showWorkFlowDialogue: boolean;
  selectableLab: SelectableLab;
  selectedLabId: string;
  processFlowList: SelectItem[] = [];
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showErrorOnSave = this.showErrorOnSave.bind(this);
    this.showErrorOnUpdate = this.showErrorOnUpdate.bind(this);
  }

  ngOnInit() {
    this.masterLists = [];
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;
    this.getprocessFlow();
    this.workFlowGroupsOptions = [
      { label: 'Artic', value: 'Artic' },
      { label: 'MidPlex', value: 'MidPlex' }
    ];

    this.processScaleOptions=[
      {label:'96', value:'96'},
      {label:'384', value:'384'}
    ];

    this.mergeInStatusOptions=[
      {label:'CONTROLS ADDED', value:'CONTROLS ADDED'}
    ];

    this.statusAfterMergeOptions=[
      {label:'MERGE COMPLETE', value:'MERGE COMPLETE'}
    ];
    this.workFlow = new WorkFlowNGS();
    console.log("NGS Workflow", this.masterLists);
  }

  handleAddNewWorkFlow() {
    this.workFlow = new WorkFlowNGS();
    this.workFlow.active = false ;
    this.showWorkFlowDialogue = true;
  }
  getprocessFlow() {
    this._masterDataService.getConfigList(this.selectedLabId, "processFlow", 0, 100, true).subscribe(
      (result)=>{
        var processFlow: ProcessFlow[] = result.data;
        if(processFlow && processFlow.length>0){
          processFlow.forEach(processFlow => {
              this.processFlowList.push({label: processFlow.processFlowName, value: processFlow.processFlowName})
        })
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }
  handleSaveOrUpdate() {
    const { _id } = this.workFlow;
    if (this.isValid()) {
      const workFlowItem: WorkFlowNGS = Object.assign({}, this.workFlow,);
      if (_id) {
        this._masterDataService.updateNGSWorkFlow(JSON.stringify(workFlowItem), this.selectedLabId, _id).subscribe((response: BBResponseContainer) => {
          this.showWorkFlowDialogue = false;
          const selectedWorkFlowIndex: number = this.masterLists.findIndex((workFlowData: WorkFlowNGS) => workFlowData._id === _id);
          this.masterLists[selectedWorkFlowIndex] = response.data;
        }, this.showErrorOnUpdate);
      } else {
        this._masterDataService.createWorkFlow(JSON.stringify(workFlowItem), this.selectedLabId, "workflowngs").subscribe((response: BBResponseContainer) => {
          const { data } = response;
          this.masterLists.push(data);
          this.showWorkFlowDialogue = false;
        }, this.showErrorOnSave);
      }
    }
  }
  showErrorOnSave() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to create work flow. Try with other work flow name, may be it is duplicate"
    });
  }
  showErrorOnUpdate() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to update work flow configurations.Try with other work flow name, may be it is duplicate"
    });
  }

  isValid() {
    const { workFlowName = '', workFlowGroup, lab, processScale } = this.workFlow;
    this.workFlow = omit(this.workFlow, ['nameError', 'locationError', 'labError', 'handlerError']);
    if (!workFlowName.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'WorkFlow name',
        detail: 'Work flow name cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    } else if (!lab) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Lab',
        detail: 'Please select the Lab'
      });
      (this.workFlow as any).labError = true;
      return false;
    } else if (!workFlowGroup) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'WorkFlow Group',
        detail: 'Work flow group cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    }else if (!processScale) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Process Scale',
        detail: 'Process Scale group cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    }
    return true;
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    const { workFlowGroup = '' } = data;
    const { processScale = '' } = data;
    const { mergeInStatus = '' } = data;
    const { statusAfterMerge = '' } = data;

    this.workFlow = cloneDeep(data);
    this.workFlow.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.workFlow.workFlowGroup = this.workFlowGroupsOptions.find((workFlowGroupsOption) => workFlowGroupsOption.value === workFlowGroup).label;
    this.workFlow.processScale = this.processScaleOptions.find((processScaleOption) => processScaleOption.value === processScale).label;
    if(mergeInStatus != '')
      this.workFlow.mergeInStatus = this.mergeInStatusOptions.find((mergeInStatusOption) => mergeInStatusOption.value === mergeInStatus).label;
    if(statusAfterMerge != '')
      this.workFlow.statusAfterMerge = this.statusAfterMergeOptions.find((statusAfterMergeOption) => statusAfterMergeOption.value === statusAfterMerge).label;
    this.showWorkFlowDialogue = true;
  }
}
